import { render, staticRenderFns } from "./ObiUserProfile.vue?vue&type=template&id=1f5322c0&"
import script from "./ObiUserProfile.vue?vue&type=script&lang=js&"
export * from "./ObiUserProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports